import { getCurrentInstance } from 'vue';
import { createStore, utils, request } from 'framework7';

// const $http=getCurrentInstance().appContext.config.globalProperties.$http;
const store = createStore({
  state: {
    loading: false,
    admin_type_list: null,
    building_type_list: null,
    county_list: null,
    country_list: null,
    floor_list: null,
    locality_type_list: null,
    locality_list: null,
    place_of_birth_list: null,
    street_type_list: null,
  },
  actions: {
    getAdminTypeList({ state }) {
      state.admin_type_list=[
        {'code':'Com.','name':'Comuna'},
        {'code':'Ors.','name':'Oraș'},
        {'code':'Mun.','name':'Municipiu'}
      ];
    },
    getBuildingTypeList({ state }) {
      state.building_type_list=[
        {'code':'bl.','name':'Bloc'},
        {'code':'corp.','name':'Corp'},
        {'code':'vila.','name':'Vila'},
        {'code':'casa.','name':'Casa'}
      ];
    },
    getPlaceOfBirthList({ state }, { county }) {
      state.loading = true;
      request({
        beforeSend: function (xhr) {
          xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
        },
        method: 'post',
        url: "/store/place_of_birth_list",
        data: { 'county':county },
        success: function(data, status, xhr) {
          state.place_of_birth_list=data;
        },
        error: function(xhr, status, message) {
          console.log(message);
        },
        complete: function (xhr, status) {
          state.loading = false;
        },
        dataType: 'json',
      });
    },
    getLocalityList({ state }, { county }) {
      state.loading = true;
      request({
        beforeSend: function (xhr) {
          xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
        },
        method: 'post',
        url: "/store/locality_list",
        data:  { 'county':county },
        success: function(data, status, xhr) {
          state.locality_list=data;
        },
        error: function(xhr, status, message) {
          console.log(message);
        },
        complete: function (xhr, status) {
          state.loading = false;
        },
        dataType: 'json',
      });
    },
    getCountyList({ state }) {
      if(state.county_list==null) {
        state.loading = true;
        request({
          beforeSend: function (xhr) {
            xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
          },
          method: 'post',
          url: "/store/county_list",
          success: function(data, status, xhr) {
            state.county_list=data;
          },
          error: function(xhr, status, message) {
            console.log(message);
          },
          complete: function (xhr, status) {
            state.loading = false;
          },
          dataType: 'json',
        });
      }
    },
    getCountryList({ state }) {
      if(state.country_list==null) {
        state.loading = true;
        request({
          beforeSend: function (xhr) {
            xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
          },
          method: 'post',
          url: "/store/country_list",
          success: function(data, status, xhr) {
            state.country_list=data;
          },
          error: function(xhr, status, message) {
            console.log(message);
          },
          complete: function (xhr, status) {
            state.loading = false;
          },
          dataType: 'json',
        });
      }
    },
    getFloorList({ state }) {
      state.floor_list=[
        {'code':'ET','name':'Etaj'},
        {'code':'PARTER','name':'Parter'},
        {'code':'MANSARDA','name':'Mansardă'}
      ];
    },
    getLocalityTypeList({ state }) {
      state.locality_type_list=[
        {'code':'Loc.','name':'Localitate'},
        {'code':'Ors.','name':'Oras'},
        {'code':'Mun.','name':'Municipiu'},
        {'code':'Sat.','name':'Sat'}
      ];
    },
    getStreetTypeList({ state }) {
      if(state.street_type_list==null) {
        state.loading = true;
        request({
          beforeSend: function (xhr) {
            xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
          },
          method: 'post',
          url: "/store/street_type_list",
          success: function(data, status, xhr) {
            state.street_type_list=data;
          },
          error: function(xhr, status, message) {
            console.log(message);
          },
          complete: function (xhr, status) {
            state.loading = false;
          },
          dataType: 'json',
        });
      }
    },
  },
  getters: {
    loading({ state }) {
      return state.loading;
    },
    admin_type_list({ state }) {
      return state.admin_type_list;
    },
    building_type_list({ state }) {
      return state.building_type_list;
    },
    country_list({ state }) {
      return state.country_list;
    },
    county_list({ state }) {
      return state.county_list;
    },
    floor_list({ state }) {
      return state.floor_list;
    },
    locality_type_list({ state }) {
      return state.locality_type_list;
    },
    place_of_birth_list({ state }) {
      return state.place_of_birth_list;
    },
    locality_list({ state }) {
      return state.locality_list;
    },
    street_type_list({ state }) {
      return state.street_type_list;
    },
  }
})

export default store;
